import LucideSymbolIcon from '../icons/LucideSymbolIcon';

const MONTHS_FULL = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const;

function formatBirthDateLabel(value: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value.trim())) return '';
  const [y, m, d] = value.split('-').map(Number);
  const monthLabel = MONTHS_FULL[m - 1] ?? String(m);
  return `${d} ${monthLabel} ${y}`;
}

type Props = {
  label: string;
  value: string;
  onChange: (isoDate: string) => void;
  required?: boolean;
};

export default function AuthDateOfBirthField({ label, value, onChange, required }: Props) {
  const displayLabel = formatBirthDateLabel(value);

  return (
    <label className="block space-y-1 sm:col-span-2">
      <span className="text-xs font-bold text-on-surface-variant">
        {label}
        {required ? ' *' : ''}
      </span>
      <div className="relative rounded-lg border border-transparent focus-glow">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2">
          <LucideSymbolIcon name="calendar_month" tone="muted" size={18} />
        </span>
        <input
          type="date"
          className="w-full rounded-lg border-none bg-surface-container-high py-2 pl-10 pr-3 text-sm text-on-surface focus:outline-none focus:ring-0 sm:py-2.5 sm:pl-11"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
        />
      </div>
      {displayLabel ? (
        <p className="text-[11px] font-medium text-on-surface-variant">{displayLabel}</p>
      ) : null}
    </label>
  );
}
